import React from "react";
import { Link } from "react-router-dom";
import { Lock, LogIn, ArrowLeft } from "lucide-react";
import styles from "./Unauthorized.module.css";

export const NotFound = ({
  appName = "ViewStruct",
  supportEmail = "support@viewstruct.am",
}) => {
  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.iconBadge}>
          <Lock size={24} strokeWidth={2} />
        </div>

        <span className={styles.eyebrow}>Error 401</span>
        <h1 className={styles.heading}>Access denied</h1>
        <p className={styles.body}>
          Your account doesn't have permission to view this page or project yet.
          Sign in with the correct account, or contact your {appName}{" "}
          administrator to request access.
        </p>

        <div className={styles.actions}>
          <Link to="/signin" className={styles.primaryBtn}>
            <LogIn size={16} />
            Sign in
          </Link>
          <Link to="/" className={styles.secondaryBtn}>
            <ArrowLeft size={16} />
            Back to home
          </Link>
        </div>

        <div className={styles.divider} />

        <p className={styles.footerText}>
          Questions about access? Contact{" "}
          <a href={`mailto:${supportEmail}`} className={styles.footerLink}>
            {supportEmail}
          </a>
        </p>
      </div>
    </div>
  );
};
